import React from 'react';
import Ad from '@ifeng-fe/ui_pc_ad';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import auth from '@ifeng-fe/ui_pc_auth';

class Footer extends React.PureComponent {
    render() {
        return (
            <footer className={styles.footer}>
                ©2019<span>凤凰视频</span>
            </footer>
        );
    }
}

export default errorBoundary(Footer);
